import { useNavigate } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import { API_BASE_URL, DEFAULT_PAGE_DESCRIPTION, DEFAULT_PAGE_TITLE } from "../../utilities/constants";
import PaginatedDropdown, { mapOptions } from "../../components/ui/PaginatedDropDown";
import MultiDropdown from "../../components/common/MultiDropdown";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";

import { useState } from "react";
import { handleApiCall } from "../../utilities/helper";
import { useUI } from "../../context/UI";

const AiLookGeneration = () => {
    const navigate = useNavigate();
    const [lookLoading, setLookLoading] = useState(false);
    const [selectedStylist, setSelectedStylist] = useState(null);
    const [selectedVibe, setSelectedVibe] = useState(null);
    const [isVibeDropdownMode, setIsVibeDropdownMode] = useState(false);
    console.log("STYLEE",selectedStylist);
    console.log("STYLEE - LABLE",selectedStylist?.label);


    const {
        addToastMessage,
        addNotification,
        setNewNotification
    } = useUI();

    const initialValues = {
        stylistId: "",
        vibe: "",
        age: "",
        height: "",
        weight: "",
        gender: "",
    }

    const validationSchema = Yup.object().shape({
        stylistId: Yup.string().required("Stylist is required"),
        vibe: Yup.string()
            .required("Vibe is required"),
        age: Yup.number()
            .typeError("Age must be a number")
            .required("Age is required")
            .integer("Age must be a whole number")
            .min(16, "Age must be at least 16")
            .max(100, "Age cannot be more than 100"),
        height: Yup.number()
            .typeError("Height must be a number")
            .required("Height is required")
            .integer("Height must be a whole number")
            .min(120, "Height must be at least 120 CM")
            .max(242, "Height cannot be more than 242 CM"),
        weight: Yup.number()
            .typeError("Weight must be a number")
            .required("Weight is required")
            .integer("Weight must be a whole number")
            .min(25, "Weight must be at least 25")
            .max(182, "Weight cannot be more than 182 KG"),
        gender: Yup.string().required("Gender is required"),
    });

    const handleLookGeneration = async (values) => {
        setLookLoading(true);
        try {
            console.log("Values:", values);
            console.log("Vibe:", values.vibe);
            const payload = {
                stylistId: values.stylistId,
                vibe: values.vibe,
                age: values.age,
                height: values.height,
                weight: values.weight,
                gender: values.gender,
                requestBy: "system",
            };

            console.log("Payload before API call:", JSON.stringify(payload, null, 2));

            const response = await handleApiCall(
                `${API_BASE_URL}/api/1.0.0/aigenlook/v3/enqueue/30`,
                {
                    method: "POST",
                    body: payload,
                }
            );

            if (response?.data?.jobId) {
                const jobId = response.data.jobId;
                const pollInterval = 5000;
                const maxAttempts = 30;

                let attempts = 0;
                let jobStatus = response.data.status;

                while (jobStatus === "PENDING" && attempts < maxAttempts) {
                    await new Promise((resolve) => setTimeout(resolve, pollInterval));
                    const statusResponse = await handleApiCall(
                        `${API_BASE_URL}/api/1.0.0/aigenlook/v2/look-job/${jobId}`,
                        { method: "GET" }
                    );

                    jobStatus = statusResponse?.data?.status;
                    attempts++;
                }

                if (jobStatus === "READY") {
                    addToastMessage({
                        status: true,
                        message: "Looks successfully generated!",
                    });
                    setNewNotification(true);
                    addNotification({
                        id: Date.now(),
                        message: "Looks generation completed successfully!",
                        status: true,
                        archive: false,
                    });

                    navigate(`/look-generation-results`, {
                        state: { jobId, stylist: selectedStylist },
                    });
                } else if (jobStatus === "FAILED") {
                    addToastMessage({
                        status: "success",
                        message: "Looks generation failed. Please try again.",
                    });
                } else {
                    addToastMessage({
                        status: "warning",
                        message: "Looks generation is taking too long. Please check again later.",
                    });
                }
            } else {
                addToastMessage({
                    status: "warning",
                    message: response?.responseDescription || "Something went wrong while creating looks. Please try again!",
                });
            }
        } catch (e) {
            console.error("Look generation error:", e);
            setNewNotification(true);
            addNotification({
                id: Date.now(),
                message: "Something went wrong while generating looks.",
                status: "error",
                archive: false,
            });
        } finally {
            setLookLoading(false);
        }
    };

    const dropdownSources = [
        {
            id: "events",
            label: "Events",
            url: `${API_BASE_URL}/api/1.0.0/aimatchedstyle/all-categories?`,
            datakey: "",
            searchkey: "keyword",
            mapOptions: (records) => mapOptions(records, "id", (o) => `${o.displayName}`),
        },
        {
            id: "vibes",
            label: "Vibes",
            url: `${API_BASE_URL}/api/1.0.0/vibecheck/vibe-questions-choices?`,
            datakey: "data",
            searchkey: "keyword",
            mapOptions: (data) => {
                const choices = data?.[0]?.choices || [];
                return choices.map(c => ({ value: c.id, label: c.choiceText }));
            },
        },
    ];

    return (
        <div className="">
            <PageMeta
                title={`Look Generation - ${DEFAULT_PAGE_TITLE}`}
                description={`Look Generation - ${DEFAULT_PAGE_DESCRIPTION}`}
            />
            <div className="flex justify-between items-center mb-">
                <PageBreadcrumb
                    pageTitle="Look Generation"
                />
            </div>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleLookGeneration}
            >
                {({ errors, touched, values, setFieldValue }) => (
                    <Form className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md max- mx-auto space-y-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <label className="block text-sm font-medium mb-1 dark:text-white"> Age</label>
                                <Field
                                    type="number"
                                    name="age"
                                    min={16}
                                    max={100}
                                    placeholder="e.g. 25"
                                    className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring focus:ring-brand-500 focus:border-brand-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-brand-500 dark:focus:border-brand-500 ${errors.age && touched.age
                                        ? "border-red-500 focus:ring-red-300"
                                        : "border-gray-300 focus:ring-brand-300 dark:border-gray-600"
                                        }`}
                                />
                                {errors.age && touched.age && (
                                    <p className="text-xs text-red-500 mt-1">{errors.age}</p>
                                )}
                            </div>
                            <div>
                                <label className="block text-sm font-medium mb-1 dark:text-white">Height (cm)</label>
                                <Field
                                    type="number"
                                    name="height"
                                    min={120}
                                    max={242}
                                    placeholder="e.g. 180"
                                    className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring focus:ring-brand-500 focus:border-brand-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-brand-500 dark:focus:border-brand-500 ${errors.height && touched.height
                                        ? "border-red-500 focus:ring-red-300"
                                        : "border-gray-300 focus:ring-brand-300 dark:border-gray-600"
                                        }`}
                                />
                                {errors.height && touched.height && (
                                    <p className="text-xs text-red-500 mt-1">{errors.height}</p>
                                )}
                            </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <label className="block text-sm font-medium mb-1 dark:text-white">  Weight (kg)</label>
                                <Field
                                    type="number"
                                    name="weight"
                                    min={25}
                                    max={182}
                                    placeholder="e.g. 70"
                                    className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring focus:ring-brand-500 focus:border-brand-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-brand-500 dark:focus:border-brand-500 ${errors.weight && touched.weight
                                        ? "border-red-500 focus:ring-red-300"
                                        : "border-gray-300 focus:ring-brand-300 dark:border-gray-600"
                                        }`}
                                />
                                {errors.weight && touched.weight && (
                                    <p className="text-xs text-red-500 mt-1">{errors.weight}</p>
                                )}
                            </div>
                            <div>
                                <label className="block text-sm font-medium mb-1 dark:text-white">Gender</label>
                                <Field
                                    as="select"
                                    name="gender"
                                    className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring focus:ring-brand-500 focus:border-brand-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-brand-500 dark:focus:border-brand-500 ${errors.gender && touched.gender
                                        ? "border-red-500 focus:ring-red-300"
                                        : "border-gray-300 focus:ring-brand-300 dark:border-gray-600"
                                        }`}
                                >
                                    <option value="">Select Gender</option>
                                    <option value="MALE">Male</option>
                                    <option value="FEMALE">Female</option>
                                </Field>
                                {errors.gender && touched.gender && (
                                    <p className="text-xs text-red-500 mt-1">{errors.gender}</p>
                                )}
                            </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <label className="block text-sm font-medium mb-1 dark:text-white"> Stylist</label>
                                <PaginatedDropdown
                                    searchkey="keyword"
                                    datakey="data"
                                    selectedValue={selectedStylist}
                                    url={`${API_BASE_URL}/api/1.0.0/aistylist/v2/stylists?type=VIRTUAL&`}
                                    mapOptions={(records) =>
                                        mapOptions(records, "id", (o) => `${o.displayName}`)
                                    }
                                    placeHolder="Select Stylist"
                                    error={errors.stylistId && touched.stylistId ? errors.stylistId : ""}
                                    onChange={(v) => {
                                        setSelectedStylist(v);
                                        setFieldValue("stylistId", v?.value || "");
                                    }}
                                />
                            </div>

                            <div>
                                <div className="flex justify-between items-center mb-1">
                                    <label className="block text-sm font-medium mb-1 dark:text-white"> Style/Events</label>
                                    <button
                                        type="button"
                                        onClick={() => setIsVibeDropdownMode(!isVibeDropdownMode)}
                                        className="text-xs text-brand-600 dark:text-brand-400 hover:underline focus:outline-none"
                                    >
                                        {isVibeDropdownMode ? "Switch to Manual Input" : "Select from List"}
                                    </button>
                                </div>
                                {isVibeDropdownMode ? (
                                    <MultiDropdown
                                        sources={dropdownSources}
                                        // selectedValue={selectedVibe}
                                        selectedValue={
                                            selectedVibe?.label
                                                ? selectedVibe
                                                : selectedVibe
                                                    ? { label: selectedVibe, value: selectedVibe }
                                                    : null
                                        }
                                        placeHolder="Select Style/Event"
                                        error={errors.vibe && touched.vibe ? errors.vibe : ""}
                                        onChange={(v) => {
                                            setSelectedVibe(v);
                                            setFieldValue("vibe", v?.label || "");
                                            console.log("Selected Vibe:", v?.label);
                                        }}
                                    />
                                ) : (
                                    <>
                                        <Field
                                            type="text"
                                            name="vibe"
                                            placeholder="e.g. old money / work"
                                            className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring focus:ring-brand-500 focus:border-brand-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-brand-500 dark:focus:border-brand-500 ${errors.vibe && touched.vibe
                                                ? "border-red-500 focus:ring-red-300"
                                                : "border-gray-300 focus:ring-brand-300 dark:border-gray-600"
                                                }`}
                                        />
                                        {errors.vibe && touched.vibe && (
                                            <p className="text-xs text-red-500 mt-1">{errors.vibe}</p>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="flex justify-end gap-3 pt-4">
                            <button
                                type="submit"
                                disabled={lookLoading}
                                className={`px-6 py-2 rounded-lg font-medium text-white transition ${lookLoading ? "bg-brand-400 cursor-not-allowed" : "bg-brand-600 hover:bg-brand-700"
                                    }`}
                            >
                                {lookLoading ? "Generating..." : "Submit"}
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default AiLookGeneration;